import { render, staticRenderFns } from "./ServicesTablePlaceholder.vue?vue&type=template&id=116f0d1b&scoped=true&lang=pug"
import script from "./ServicesTablePlaceholder.vue?vue&type=script&lang=ts"
export * from "./ServicesTablePlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./ServicesTablePlaceholder.vue?vue&type=style&index=0&id=116f0d1b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f0d1b",
  null
  
)

export default component.exports